// Import model
import { FilterPaymentTermsRequest } from '../models/FilterPaymentTermsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { PaymentTermsCondition } from '../models/PaymentTermsCondition';
import { PaymentTermsFields } from '../models/PaymentTermsFields';
import { PaymentTermsIndexedFields } from '../models/PaymentTermsIndexedFields';

// Import dependency serializers (for complex types)
import { PaymentTermsConditionSerializer } from './PaymentTermsConditionSerializer';
import { PaymentTermsFieldsSerializer } from './PaymentTermsFieldsSerializer';
import { PaymentTermsIndexedFieldsSerializer } from './PaymentTermsIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterPaymentTermsRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterPaymentTermsRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterPaymentTermsRequest instance
   */
  static deserialize(json: string): FilterPaymentTermsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterPaymentTermsRequest instance
   */
  static fromObject(obj: any): FilterPaymentTermsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterPaymentTermsRequest');
    }


    const instance: FilterPaymentTermsRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as PaymentTermsIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as PaymentTermsFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        PaymentTermsConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterPaymentTermsRequest instances
   */
  static deserializeArray(json: string): FilterPaymentTermsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterPaymentTermsRequest instance to a JSON string
   */
  static serialize(instance: FilterPaymentTermsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterPaymentTermsRequest instance to a plain object
   */
  static toObject(instance: FilterPaymentTermsRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        PaymentTermsConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterPaymentTermsRequest instances to a JSON string
   */
  static serializeArray(instances: FilterPaymentTermsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
